// extracted by mini-css-extract-plugin
export default {"uppercase":"uppercase__CUvBs","hidden":"hidden__J0roS","profileAppContainer":"profileAppContainer__lxSN5","profileDropDown":"profileDropDown__SnxJP"};